import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { StyleClass } from 'primereact/styleclass';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode } from 'primereact/api';
import MmService from '../../service/MmService';

import { useHotkeys } from 'react-hotkeys-hook';

// Import related store

import { useVno } from '../../store/index';
import { useNamenaPotrosnje } from '../../store/index';

import { useUsers, useMrs } from '../../store/index';

import i18n from '../../i18n';

const MmSelect = ({ onAfterSelect }) => {
    const [models, setModels] = useState();

    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState();
    const [loading, setLoading] = useState(true);

    // refs
    const dt = useRef(null);

    // related models values

    const { vnos } = useVno((state) => ({ vnos: state.vnos }));
    const { namenaPotrosnjes } = useNamenaPotrosnje((state) => ({ namenaPotrosnjes: state.namenaPotrosnjes }));
    const { mrss } = useMrs((state) => ({ mrss: state.mrss }));

    // init state for lazy loading
    // from local storage or default
    const [lazyState, setlazyState] = useState(JSON.parse(localStorage.getItem('dt-state-mm-local')) || { first: 0, rows: 10, sortField: 'id', sortOrder: -1, filters: {} });

    const navigate = useNavigate();

    useHotkeys('F8', () => {
        navigate('/mm/new');
    });

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const clearFilter = () => {
        initFilters();
    };

    const paginatorLeft = <Button type="button" icon="pi pi-refresh" label="" outlined onClick={clearFilter} />;
    const paginatorRight = <Button type="button" icon="pi pi-download" onClick={() => exportCSV(false)} outlined data-pr-tooltip="Excel" />;

    const { getMmsLazy } = MmService();

    const initFilters = () => {
        const initFiltersObject = {
            id: { value: null, matchMode: FilterMatchMode.CONTAINS },

            sifra_mm: { value: null, matchMode: FilterMatchMode.CONTAINS },

            m_id: { value: null, matchMode: FilterMatchMode.CONTAINS },

            m_barkod: { value: null, matchMode: FilterMatchMode.CONTAINS },

            p_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
            p_sifra_potrosaca: { value: null, matchMode: FilterMatchMode.CONTAINS },

            sifra_ulice: { value: null, matchMode: FilterMatchMode.CONTAINS },

            ulica: { value: null, matchMode: FilterMatchMode.CONTAINS },

            kucni_broj: { value: null, matchMode: FilterMatchMode.CONTAINS },

            postanski_broj: { value: null, matchMode: FilterMatchMode.CONTAINS },

            mesto: { value: null, matchMode: FilterMatchMode.CONTAINS },

            mrs_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
            mrs_sifra: { value: null, matchMode: FilterMatchMode.CONTAINS },

            vno_id: { value: null, matchMode: FilterMatchMode.CONTAINS },

            namena_potrosnje_id: { value: null, matchMode: FilterMatchMode.CONTAINS },

            kordinata_x: { value: null, matchMode: FilterMatchMode.CONTAINS },

            kordinata_y: { value: null, matchMode: FilterMatchMode.CONTAINS },

            datum_zamene_meraca: { value: null, matchMode: FilterMatchMode.CONTAINS },

            datum_pregleda_kgp: { value: null, matchMode: FilterMatchMode.CONTAINS },

            datum_pregleda_ugi: { value: null, matchMode: FilterMatchMode.CONTAINS },

            created_by: { value: null, matchMode: FilterMatchMode.CONTAINS },

            updated_by: { value: null, matchMode: FilterMatchMode.CONTAINS },

            created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },

            updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        setFilters(initFiltersObject);

        const resetLazyStateFilters = { ...lazyState };
        resetLazyStateFilters.filters = initFiltersObject;
        setlazyState(resetLazyStateFilters);
    };

    useEffect(() => {
        loadLazyData();
    }, [lazyState]); // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        setLoading(true);

        // convert filters to params
        let filters = {};
        for (const key in lazyState.filters) {
            if (lazyState.filters[key].value) {
                filters[key + '[value]'] = lazyState.filters[key].value;
                filters[key + '[matchMode]'] = lazyState.filters[key].matchMode;
            }
        }

        // convert layiState to params
        const params = {
            page: lazyState.first / lazyState.rows + 1,
            perPage: lazyState.rows,
            sortBy: lazyState.sortField,
            sortOrder: lazyState.sortOrder > 0 ? 'asc' : 'desc',
            ...filters
        };

        getMmsLazy(params).then((res) => {
            setModels(res.data);
            setLoading(false);
            // console.log(res.meta.total);
            setTotalRecords(res.meta.total);
        });
    };

    const onPage = (event) => {
        setlazyState(event);
    };

    const onSort = (event) => {
        setlazyState(event);
    };

    const onFilter = (event) => {
        setFilters(event.filters);
        setlazyState(event);
    };

    const filterNamenaPotrosnje = (options) => {
        return <Dropdown value={options.value} options={namenaPotrosnjes} onChange={(e) => options.filterApplyCallback(e.value)} optionLabel="opis" optionValue="id" className="p-column-filter" />;
    };

    const filterMrs = (options) => {
        return <Dropdown value={options.value} options={mrss} onChange={(e) => options.filterApplyCallback(e.value)} optionLabel="naziv" optionValue="id" className="p-column-filter" />;
    };

    const tooltipOptions = { position: 'bottom', mouseTrack: false, mouseTrackTop: 15, showDelay: 300 };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-left">
                <span className="p-input-icon-left">
                    <Link to={`/mm/new`}>
                        <Button tooltip={i18n.t('create')} label={i18n.t('add')} tooltipOptions={tooltipOptions} className="mr-2" type="button" icon="pi pi-plus " outlined onClick={clearFilter} />
                    </Link>
                </span>

                <span className="p-input-icon-left">
                    <Button type="button" tooltip={i18n.t('clear_filters')} icon="pi pi-filter-slash " tooltipOptions={tooltipOptions} label={i18n.t('clear_filters')} outlined onClick={clearFilter} />
                </span>
            </div>
        );
    };

    const header = renderHeader();

    const onSelect = (rowData) => {
        if (onAfterSelect) onAfterSelect(rowData);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button outlined tooltip={i18n.t('select')} label={i18n.t('select')} tooltipOptions={tooltipOptions} icon="pi pi-check" rounded severity="info" aria-label="Odaberi" onClick={() => onSelect(rowData)} />
            </React.Fragment>
        );
    };

    const bodyM = (rowData) => {
        //return <pre>{JSON.stringify(rowData['m'], null, 2)}</pre>;
        return rowData['m']['barkod_meraca'] ? rowData['m']['barkod_meraca'] : '-';
    };

    const bodyP = (rowData) => {
        return rowData['p']['sifra_potrosaca'] ? rowData['p']['sifra_potrosaca'] : '-';
    };

    const bodyMrs = (rowData) => {
        return rowData['mrs']['sifra_mrs'] ? rowData['mrs']['sifra_mrs'] : '-';
    };

    const bodyNamenaPotrosnje = (rowData) => {
        return <span>{rowData['namena_potrosnje'] && rowData['namena_potrosnje']['opis'] ? rowData['namena_potrosnje']['opis'] : '-'}</span>;
    };

    return (
        <div className="card">
            <h5>{i18n.t('mm.model')}</h5>

            <DataTable
                onRowDoubleClick={(row, event) => {
                    onAfterSelect(row.data);
                }}
                ref={dt}
                value={models}
                rows={lazyState.rows}
                lazy
                first={lazyState.first}
                totalRecords={totalRecords}
                onPage={onPage}
                paginator
                paginatorLeft={paginatorLeft}
                // paginatorRight={paginatorRight}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                onSort={onSort}
                sortField={lazyState.sortField}
                sortOrder={lazyState.sortOrder}
                sortMode="single"
                onFilter={onFilter}
                filters={filters}
                filterDisplay="row"
                loading={loading}
                header={header}
                size={'small'}
                stripedRows
                stateStorage="local"
                stateKey="dt-state-mm-local"
                dataKey="id"
                showGridlines
                scrollable
            >
                {/* <Column selectionMode="multiple" frozen alignFrozen="left" headerStyle={{ width: '3rem' }}></Column>  */}

                {/* <Column key={'id'} sortable field={'id'} filter header={i18n.t('mm.id')} headerStyle={{ minWidth: '8rem' }} /> */}
                <Column key={'mrs_id'} sortable field={'mrs_id'} filter body={bodyMrs} filterElement={filterMrs} header={i18n.t('mm.mrs_id')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'sifra_mm'} sortable field={'sifra_mm'} filter header={i18n.t('mm.sifra_mm')} headerStyle={{ minWidth: '10rem' }} />
                {/* <Column key={'m_id'} sortable field={'m_id'} filter filterElement={filterM} body={bodyM} header={i18n.t('mm.m_id')} /> */}
                <Column key={'m_barkod'} sortable field={'m_barkod'} filter body={bodyM} header={i18n.t('mm.m_barkod')} headerStyle={{ minWidth: '10rem' }} />

                {/* <Column key={'p_id'} sortable field={'p_id'} filter filterElement={filterP} body={bodyP} header={i18n.t('mm.p_id')} /> */}
                <Column key={'p_sifra_potrosaca'} sortable field={'p_sifra_potrosaca'} filter body={bodyP} header={i18n.t('mm.p_sifra_potrosaca')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'sifra_ulice'} sortable field={'sifra_ulice'} filter header={i18n.t('mm.sifra_ulice')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'ulica'} sortable field={'ulica'} filter header={i18n.t('mm.ulica')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'kucni_broj'} sortable field={'kucni_broj'} filter header={i18n.t('mm.kucni_broj')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'postanski_broj'} sortable field={'postanski_broj'} filter header={i18n.t('mm.postanski_broj')} headerStyle={{ minWidth: '10rem' }} />

                <Column key={'mesto'} sortable field={'mesto'} filter header={i18n.t('mm.mesto')} headerStyle={{ minWidth: '10rem' }} />

                {/* <Column key={'mrs_id'} sortable field={'mrs_id'} filter filterElement={filterMrs} body={bodyMrs} header={i18n.t('mm.mrs_id')} /> */}

                {/* <Column key={'vno_id'} sortable field={'vno_id'} filter filterElement={filterVno} body={bodyVno} header={i18n.t('mm.vno_id')} /> */}

                <Column key={'namena_potrosnje_id'} sortable field={'namena_potrosnje_id'} filter filterElement={filterNamenaPotrosnje} body={bodyNamenaPotrosnje} header={i18n.t('mm.namena_potrosnje_id')} />

                {/* <Column key={'kordinata_x'} sortable field={'kordinata_x'} filter header={i18n.t('mm.kordinata_x')} /> */}

                {/* <Column key={'kordinata_y'} sortable field={'kordinata_y'} filter header={i18n.t('mm.kordinata_y')} /> */}

                {/* <Column key={'datum_zamene_meraca'} sortable field={'datum_zamene_meraca'} filter header={i18n.t('mm.datum_zamene_meraca')} /> */}

                {/* <Column key={'datum_pregleda_kgp'} sortable field={'datum_pregleda_kgp'} filter header={i18n.t('mm.datum_pregleda_kgp')} /> */}

                {/* <Column key={'datum_pregleda_ugi'} sortable field={'datum_pregleda_ugi'} filter header={i18n.t('mm.datum_pregleda_ugi')} /> */}

                <Column body={actionBodyTemplate} exportable={true} frozen alignFrozen="right" headerStyle={{ minWidth: '3rem' }}></Column>
            </DataTable>
        </div>
    );
};

export default MmSelect;
